module.exports = __webpack_public_path__ + "img/c03_buildingtechriteofandrasta_Normal_ua.f29f5ef0.webp";